<pp-new-dashlet-modal-cost-fields
  [ppAssetId]="assetId"
  (ppAddDashlet)="editDashlet($event)"
  [ppNewDashlet]="false"
  [ppInitialRows]="initialDashletData"
  (ppDeleteDashlet)="deleteDashlet()"
  [ppInitialName]="initialDashletName"
>
</pp-new-dashlet-modal-cost-fields>
